<template>
  <!-- 售后列表头部信息 -->
  <div class="re_header_con border_bottom1px">
    <div class="header_left">
      <!-- <img src="@/assets/order/icon_order1@2x.png" alt="" class="header_icon" /> -->
      <div class="left_id font12 font_weight400 colo087 line_height_24">
        服务单号：{{ item.id }}
      </div>
    </div>
    <div class="header_left mr_top">
      <div class="right_right">
        <img
          src="@/assets/order/icon_refund_money@2x.png"
          alt=""
          class="right_icon"
        />
        <span
          class="font12 font_weight500 colo087 line_height_17 re_font left_id"
          >{{ item.afterSaleType === 1 ? "退货退款" : "退款" }}</span
        >
        <div class="line_r"></div>
      </div>
      <div class="right_font font12 font_weight500 colo087 line_height_17">
        {{ item.status | statusFilter }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  filters: {
    statusFilter(status) {
      //   FINANCE_REJECT( -32, "财务售后驳回"),
      // ADMIN_TAKEOVER_REJECT( -31, "小二收货驳回"),
      // ADMIN_REJECT( -30, "小二售后驳回"),
      // USER_CANCEL( -1, "撤销售后"),
      // SERVICE_EXAMINING( 1, "客服审核中"),
      // ADMIN_EXAMINE_PASS( 30, "小二审核通过"),
      // TO_BE_RETURNED( 31, "待商品寄回"),
      // DIST_FIRM( 32, "待商家收货"),
      // FINANCE_EXAMINING( 33, "待财务审核"),
      // REFUNDING( 34, "退款中"),
      // AFTER_SALE_SUCCESS( 35, "售后成功");
      switch (status) {
        case -32: // return "财务售后驳回";
        case -31: // return "小二收货驳回";
        case -30: // return "小二售后驳回";
          return "退款失败";
        case -1: // return "撤销售后";
          return "撤销售后";
        case 1:
          return "客服审核中";
        case 30: //return "小二审核通过";
        case 31:
          return "待商品寄回";
        case 32:
        case 33: //return "待财务审核";
          return "待商家收货";
        case 34: //return "退款中";
        case 35:
          return "退款成功";
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.re_header_con {
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  .header_left {
    display: flex;
    .header_icon {
      width: 24px;
      height: 24px;
    }
    .left_id {
      margin-left: 4px;
    }
  }
  .re_font {
    vertical-align: middle;
  }
  .right_icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  .right_right {
    font-size: 0;
    display: flex;
    margin-right: 8px;
  }
  .mr_top {
    margin-top: 4px;
  }
  .right_font {
    color: #d91818;
  }
  .line_r {
    width: 1px;
    height: 10px;
    background: rgba(0, 0, 0, 0.38);
    border-radius: 1px;
    margin-left: 8px;
    margin-top: 2px;
  }
}
</style>
